import angular from "angular";

angular
    .module('app')
    .component('lectureForm', {
        template: require('./lecture-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.title = null;
    $ctrl.content = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.chapter = $ctrl.resolve.chapter;
        if ($ctrl.resolve.lecture) {
            $ctrl.id = $ctrl.resolve.lecture.id;
            $ctrl.title = $ctrl.resolve.lecture.title;
            $ctrl.content = $ctrl.resolve.lecture.content;
        }
    };

    $ctrl.submit = function () {

        let req = null;

        let params = {title: $ctrl.title, content: $ctrl.content, chapter_id: $ctrl.chapter.id};

        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/lectures/${$ctrl.id}`, params);
        } else {
            req = $http.post(`/lectures`, params);
        }

        req.then(
            function (response) {
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    Notifier.success('Chapter created', 2);
                } else {
                    Notifier.success('Chapter updated', 2);
                }
                $ctrl.close({$value: {id: $ctrl.id, title: $ctrl.title, content: $ctrl.content}});
            },
            function (error) {
                ErrorResponseParser.parse(error);
            }
        );
    };

}
